import React, { useState, memo, useEffect } from "react";
import DialogLoyalty from "../DialogLoyalty";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

const ProgramLoyalty = memo(props => {
	const classes = useStyles();
	const {
		listLoyalty,
		handleClickProgramLoyalty,
		loyaltyDetail,
		setSpecialOfferDetail,
		business
	} = props;
	const history = useHistory();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!isEmpty(loyaltyDetail)) {
			setOpen(true);
		}
	}, [loyaltyDetail]);

	const handleClose = () => {
		setOpen(false);
	};

	const handleClickProgram = (id, type) => {
		if (type === "GIFT") {
			handleClickProgramLoyalty(id);
			setOpen(true);
		} else {
			const data = {
				business: business,
				id: id
			};
			setSpecialOfferDetail(data);
			history.push(`/special_offer_detail?id=${id}`);
		}
	};

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.root }}>
				<Grid classes={{ root: classes.title }}>
					<img src={Images.titleLoyalty} alt={"titleLoyalty"} />
				</Grid>
				{listLoyalty.map(product => (
					<Grid
						container
						classes={{ root: classes.body }}
						key={product?.id}
						onClick={() => handleClickProgram(product.id)}
					>
						<Grid item xs={4} classes={{ root: classes.logo }}>
							<Grid classes={{ root: classes.bgLogo }} />
						</Grid>
						<Grid item xs={8} classes={{ root: classes.program }}>
							<Grid classes={{ root: classes.borderTitle }}>
								<Grid classes={{ root: classes.titleProgram }}>
									{product?.name}
								</Grid>
								<img src={Images.icInfoBlue} alt="icInfoBlue" />
							</Grid>
							<Grid classes={{ root: classes.time }}>
								TG tích điểm:{" "}
								{`${product?.startTimeApply} - ${product?.endTimeApply}`}
							</Grid>
							<Grid classes={{ root: classes.time }}>
								TG sử dụng điểm:{" "}
								{`${product?.pointExpirationDate}`}
							</Grid>
							<Grid classes={{ root: classes.time }}>
								TG trả thưởng:{" "}
								{`${product?.startTimeReward} - ${product?.endTimeReward}`}
							</Grid>
						</Grid>
					</Grid>
				))}
			</Grid>
			<DialogLoyalty
				open={open}
				handleClose={handleClose}
				loyaltyDetail={loyaltyDetail}
			/>
		</React.Fragment>
	);
});

export default ProgramLoyalty;
